import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import config from "../../config";
import { getLanguageHeaders } from "../services/http-common";
import { isBackofficeUser } from "../../utilities/authentication";

export const LoginHand = createAsyncThunk("login/LoginHand", async (userData, thunkAPI) => {
    const { rejectWithValue, fulfillWithValue, dispatch } = thunkAPI
    try {
        const response = await fetch(`${config.apiRootUrl}/backoffice/login`, {
            method: "POST",
            body: JSON.stringify(userData),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                ...getLanguageHeaders(),
            }

        })

        const data = await response.json();
        if (!response.ok) {
            return rejectWithValue(data)
        } else {
            const normalizedPayload = {
                token: data?.token ?? data?.data?.token ?? null,
                user: data?.user ?? data?.data?.user ?? null,
                message: data?.message ?? data?.data?.message ?? "Login successful"
            }

            if (!isBackofficeUser(normalizedPayload.user)) {
                if (typeof window !== "undefined") {
                    localStorage.removeItem("jwt")
                    localStorage.removeItem("user")
                }
                return rejectWithValue({
                    message: data?.message ?? "This account cannot access the backoffice portal.",
                })
            }

            dispatch(authentication(normalizedPayload))

            if (typeof window !== "undefined") {
                window.location.assign("/")
            }

            return fulfillWithValue(normalizedPayload)
        }
    } catch (error) {
        return rejectWithValue({ message: error?.message ?? "Unexpected error" })
    }
})


export const LoginSlice = createSlice({
    name: "login",
    initialState: { user: null, token: null, error: null, loading: false },
    reducers: {
        authentication: (state, action) => {
            if (typeof window !== "undefined") {
                const { token, user } = action.payload || {}

                if (token) {
                    localStorage.setItem("jwt", token)
                } else {
                    localStorage.removeItem("jwt")
                }

                if (user) {
                    localStorage.setItem("user", JSON.stringify(user))
                } else {
                    localStorage.removeItem("user")
                }
            }
        },
    },
    extraReducers: {
        [LoginHand.pending]: (state, action) => {
            state.loading = true
            state.error = null
        },
        [LoginHand.fulfilled]: (state, action) => {
            state.loading = false
            state.user = action.payload?.user ?? null
            state.token = action.payload?.token ?? null
            state.error = null
        },
        [LoginHand.rejected]: (state, action) => {
            state.loading = false
            state.error = action.payload?.message ?? "Unable to login"
        },
    }
})

export default LoginSlice.reducer;
export const { authentication } = LoginSlice.actions